import React from 'react';
import '../../base.scss';
import './Pill.scss';
import { Button } from '..';
import { classNames } from '../..';

export interface PillProps {
  /** Text to be shown on pill */
  text: string;
  /** Pill can be disabled
   * @default false
  */
  disabled?: boolean;
  /** CSS class name to apply */
  className?: string;
  /** Callback when user clicks to close a pill */
  onClose: (text: string) => void;
}

const Pill = (props: PillProps) => {
  const {
    text,
    disabled = false,
    className = '',
    onClose,
  } = props;

  const pillClasses = classNames(
    'ps-pill',
    disabled ? 'ps-pill--disabled' : '',
    className
  );

  return (
    <span className={pillClasses} >
      <span>{text}</span>
      <Button
        aria-label="Close"
        className="ps-pill--close"
        disabled={disabled}
        icon="Close"
        onClick={() => onClose(text)}
        variant="icon-only"
      >
      </Button>
    </span>
  );
};

export { Pill };
